import React from 'react'
import PropTypes from 'prop-types'

const Label = ({ children, title, htmlFor }) => {
  const labelTitle = title || typeof children === 'string' ? children : null
  return (
    <label
      title={labelTitle}
      htmlFor={htmlFor}
    >
      {children}
    </label>
  )
}

Label.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  htmlFor: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}

export default Label
